import { fetched, error, fetching } from './amenities.types'

export const fetchAmenities = () => ({ type: fetching })
export const fetchedAmenities = payload => ({ type: fetched, payload })
export const errorFetchingAmenities = msg => ({ type: error, error: msg })
